import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Select from '../../form/Select'
import Button from '../../../UniformComponents/Button'
import Panel from '../../../UniformComponents/Panel'
import Spinner from '../../../UniformComponents/Spinner'

@observer
export default class ProductSearch extends Component {
    constructor(props) {
        super(props)
        this.productName = null
        this.isVenue = props.wizardStore.industry === 'VENU'
        this.state = {
            showError: false,
            openAccordion: false,
        }
    }

    async componentDidMount() {
        const { wizardStore } = this.props

        await wizardStore.initProductSearch(wizardStore.industry, wizardStore.surveyType)
        wizardStore.handleValidate = this.validate
    }

    toggleAccordion = () => {
        this.setState((prevState) => ({
            openAccordion: !prevState.openAccordion,
        }))
    }

    validatePortfolios = async () => {
        const { wizardStore, store } = this.props
        const allPortfolios = await store.http.get('/portfolio')
        const availablePortfolios = allPortfolios.filter((p) => p.industry === wizardStore.industry)
        let valid = true
        if (availablePortfolios.length < 1) {
            store.handleError({ body: i18n.t('views.survey.wizard.no_available_portfolios'), level: 'error' })
            valid = false
        }
        return valid
    }

    goToProductNew = async () => {
        const { wizardStore } = this.props
        const validatePortfolios = await this.validatePortfolios(wizardStore)
        if (!validatePortfolios) return
        wizardStore.hideProductNew = false
        wizardStore.goNext()
    }

    validate = () => {
        const { wizardStore } = this.props
        const { survey: { metadata: { productInfo } } } = wizardStore
        const { industrySpecificInfo } = productInfo

        const isValid = (parseInt(productInfo.productId, 10) > 0
            && industrySpecificInfo.productType
            && industrySpecificInfo.portfolioId)

        if (!isValid) this.setState({ showError: true })

        return isValid
    }

    getNewEventBtnLabel = () => {
        const { wizardStore: { surveyType } } = this.props
        const { isVenue } = this
        if (isVenue) return 'surveyWizard.newEvent.VENU.accordion.title'
        if (surveyType === 'EM') return 'surveyWizard.newEvent.EM.accordion.title'
        return 'surveyWizard.newEvent.accordion.title'
    }

    render() {
        const { wizardStore, store, handleContinue } = this.props
        const { showError } = this.state

        if (wizardStore.surveySearchLoading) return <Spinner />

        return (
            <div id="product-search">
                <Panel cssClass="stage-card overflow-visible">
                    <h4 className="search-title">
                        {i18n.t(this.isVenue
                            ? 'surveyWizard.newEvent.VENU.select'
                            : 'surveyWizard.newEvent.searchEvent')}
                    </h4>
                    <Select
                        placeholder={i18n.t('please_select')}
                        value={wizardStore.selectedProduct}
                        options={wizardStore.productOptions}
                        onBlur={wizardStore.assignProductSearch}
                        isSearchable
                    />
                    <Button
                        label={i18n.t('continue')}
                        cssClass="regular primary"
                        style={{ width: '100%', justifyContent: 'center' }}
                        onClick={handleContinue}
                    />
                    {showError && (
                        <p className="survey-error">
                            {i18n.t(`surveyWizard.productSearch.searchError${wizardStore.industry === 'VENU' ? '.VENU' : ''}`)}
                        </p>
                    )}
                </Panel>

                {(store.userData.role <= 130) && (
                    <>
                        <h4>{i18n.t('surveyWizard.divider_or')}</h4>
                        <Panel cssClass="stage-card overflow-visible">
                            <div className="create-new-event">
                                <h4>
                                    {i18n.t(this.isVenue
                                        ? 'surveyWizard.newEvent.VENU.select'
                                        : 'surveyWizard.newEvent.searchEvent.createNewEvent.1')}
                                </h4>
                                <div className="info-btn-wrapper">
                                    <Button
                                        cssClass="tertiary regular"
                                        icon="fa-solid fa-plus"
                                        style={{ width: '100%', justifyContent: 'center' }}
                                        label={i18n.t(this.getNewEventBtnLabel())}
                                        onClick={this.goToProductNew}
                                    />
                                </div>
                                <div className="disclaimer">
                                    <i className="fa-light fa-circle-info" />
                                    {i18n.t(this.isVenue
                                        ? 'surveyWizard.newEvent.VENU.disclaimer'
                                        : 'surveyWizard.newEvent.searchEvent.createNewEvent.2')}
                                </div>
                            </div>
                        </Panel>
                    </>
                )}
            </div>
        )
    }
}
